let clone = require('clone');
export class Cloner {
	public static clone(originalObject: any) {
		return clone(originalObject)
	}
	public static shallowCopyArray(obj: any): any {
		return obj = [...obj];
	}
}


// WEBPACK FOOTER //
// ./src/app/services/cloner.ts